<i18n src="@/lang/services.json"></i18n>
<i18n src="@/lang/messages.json"></i18n>
<i18n>
  {
  "en": {
  "service-info": "Info",
  "found":"found {count} more",
  "check":"Check"
  },
  "ua": {
  "service-info": "Info",
  "found":"знайдено ще {count}",
  "check":"Перевірити"
  },
  "ru": {
  "service-info": "Info",
  "found":"найдено еще {count}",
  "check":"Проверить"
  }
  }
</i18n>

<template>
  <el-col>
    <section-divider icon="el-icon-info" :text="$t('service-info')" />
    <el-row>
      <el-col>
        <template v-for="(v, key) in details">
          <div
            :key="key"
            class="customer-details-info"
            v-if="v && !(service.hasIntegration && key === 'integration')"
          >
            <span class="customer-details-info--label">
              <i v-bind="v.status.icon" />
              {{ $t("services.details." + key) }}
            </span>
            <span
              v-text="v.value"
              class="customer-details-info--value"
              @mouseenter.once="showTooltip"
            />
          </div>
        </template>
        <template v-if="service.hasIntegration">
          <div class="customer-details-info">
            <span class="customer-details-info--label">
              <i v-bind="integrationStatus" />
              {{ $t("services.details.integration") }}
            </span>
            <template v-if="checkedIntegrations === undefined">
              <el-button
                style="padding-bottom: 0"
                type="text"
                v-text="$t('check')"
                v-if="service.sharedAmocrm_uuid && service.sharedWidgets_uuid"
                @click.once="checkIntegration"
              />
            </template>
            <template v-else>
              <span
                v-text="integrationText"
                class="customer-details-info--value"
                @mouseenter.once="showTooltip"
              />
            </template>
          </div>
        </template>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
import SectionDivider from "../SectionDivider";

export default {
  name: "service-info-section",
  components: { SectionDivider },
  props: {
    service: Object
  },
  data: () => ({
    checkedIntegrations: undefined
  }),
  methods: {
    showTooltip(...args) {
      let el = args[0].target;
      if (el.offsetWidth < el.scrollWidth && !el.getAttribute("title")) {
        el.setAttribute("title", el.innerText);
      }
    },
    checkIntegration() {
      this.checkedIntegrations = [];
      this.$api
        .query({
          query: require("../../../../graphql/opupet_query.graphql"),
          variables: {
            class: "\\App\\JStorage\\SPA\\JSSharedIntegrations",
            method: "getWidgetIntegrationsForAmocrm",
            params: [
              this.service.sharedAmocrm_uuid,
              this.service.sharedWidgets_uuid
            ]
          }
        })
        .then(res => {
          this.checkedIntegrations = res.data.opupet_query;
          this.$notify.success({
            message: this.$t("messages.checked")
          });
        })
        .catch(() => {
          this.checkedIntegrations = undefined;
          this.$notify.error({
            message: this.$t("messages.something_went_wrong")
          });
        });
    }
  },
  computed: {
    details() {
      try {
        return this.service.details;
      } catch (e) {}
      return {};
    },
    integrationsCount() {
      try {
        return this.checkedIntegrations.length;
      } catch (e) {
        return 0;
      }
    },
    integrationStatus() {
      let _class = this.service.hasIntegration
        ? [0, 1].includes(this.integrationsCount)
          ? "el-icon-check"
          : "el-icon-warning-outline"
        : "el-icon-close";
      let color = this.service.hasIntegration
        ? [0, 1].includes(this.integrationsCount)
          ? this.integrationsCount === 1
            ? "green"
            : "unset"
          : "orange"
        : "red";
      return {
        class: _class,
        style: {
          color
        }
      };
    },
    integrationText() {
      return this.integrationsCount === 1
        ? "Ok"
        : this.integrationsCount === 0
        ? ""
        : this.$t("found", { count: this.integrationsCount - 1 });
    }
  }
};
</script>

<style scoped lang="stylus">
.customer-details-info
  display flex
  justify-content space-between
  margin 20px 0 0
  border-bottom 1px inset
  padding-bottom 1px

  & > span
    white-space nowrap

  & &--label
    background-color #666666
    background-clip text
    color transparent
    text-shadow rgba(255, 255, 255, 0.5) 0px 3px 3px

    &:after
      content ":"

  & &--value
    text-align end
    text-overflow ellipsis
    overflow hidden
    height 1.2em
    white-space nowrap
</style>
